import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AddDocument, DocumentActive, EditDocument, FunctieAssignmentRequest } from './document-types.interface';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentTypesService {
    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.tipuri
            .public;

    // OLD, to remove!!
    private userURL =
        this.basePath + environment.interop.indoc.user.getUserAccess;

    // private getUsersDirectieAndCompartiment =
    //     this.basePath + environment.interop.indoc.user.getUsersDirectieCompartiment;

    // private getCompartimente =
    //     this.basePath + environment.interop.indoc.user.getCompartiment;

    // private getDirectii =
    //     this.basePath + environment.interop.indoc.user.getDirectii;

    // private getCompartimentList =
    //     this.basePath + environment.interop.indoc.user.getCompartiment;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddDocument) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: EditDocument) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }


    // OLD, to remove!! -> use commonService.getUsers()!
    // getUserAccess(): Observable<{ id_user: number; name: string }[]> {
    //     return this.http.get<{ id_user: number; name: string }[]>(this.userURL);
    // }

    // // OLD, to remove!! -> use commonService.getUsers()!
    // getUserOperator() {
    //     return this.http
    //         .get<{ errors: boolean; data: any[]; status_code: number }>(this.userURL)
    //         .pipe(
    //             map((response) =>
    //                 response.data.map((item) => ({
    //                     id: item.id_user,
    //                     name: item.name,
    //                 }))
    //             ),
    //             catchError((error) => {
    //                 console.error('Error in get user operator:', error);
    //                 return throwError(error);
    //             })
    //         );
    // }

    // OLD, to remove!! -> use commonService
    // getDirectieAndCompartiment() {
    //     return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(
    //         this.getUsersDirectieAndCompartiment
    //     );
    // }

    // getDirectie() {
    //     return this.http
    //         .get<{ errors: boolean; data: any[]; status_code: number }>(
    //             this.getDirectii
    //         )
    //         .pipe(
    //             map((response) =>
    //                 response.data.map((item) => ({
    //                     id: item.id_directie,
    //                     name: item.name,
    //                 }))
    //             ),
    //             catchError((error) => {
    //                 console.error('Error in get directii:', error);
    //                 return throwError(error);
    //             })
    //         );
    // }

    // getCompartimentByDirectieId(id: any) {
    //     return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(
    //         this.getCompartimentList,
    //         id
    //     );
    // }

    // getCompartiment() {
    //     return this.http
    //         .get<{ errors: boolean; data: any[]; status_code: number }>(
    //             this.getCompartimente
    //         )
    //         .pipe(
    //             map((response) =>
    //                 response.data.map((item) => ({
    //                     id: item.id_compartiment,
    //                     name: item.name,
    //                     id_directie: item.id_directie,
    //                     directie_name: item.directie_name,
    //                 }))
    //             ),
    //             catchError((error) => {
    //                 console.error('Error in get user compartimente:', error);
    //                 return throwError(error);
    //             })
    //         );
    // }

    // OLD, to remove!! -> use commonService.getDocumenteActive()!
    getActiveList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({ id: item.id, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in get active docs:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    // ============================================================================
    // Functie Assignment Management Methods
    // ============================================================================

    /**
     * Get functie assignments for a cerere type
     */
    getFunctieAssignments(documentTypeId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/${documentTypeId}/functie-assignments`;
        return this.http.get(url, this.httpOptions);
    }

    /**
     * Update functie assignments for a cerere type
     */
    updateFunctieAssignments(documentTypeId: number, request: FunctieAssignmentRequest): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/${documentTypeId}/functie-assignments`;
        return this.http.put(url, request, this.httpOptions);
    }

    /**
     * Delete a specific functie assignment
     */
    deleteFunctieAssignment(documentTypeId: number, assignmentId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/${documentTypeId}/functie-assignments/${assignmentId}`;
        return this.http.delete(url, this.httpOptions);
    }

    /**
     * Reorder functie assignments
     */
    reorderFunctieAssignments(documentTypeId: number, assignmentIds: number[]): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/${documentTypeId}/functie-assignments/reorder`;
        return this.http.put(url, { assignment_ids: assignmentIds }, this.httpOptions);
    }

    /**
     * Get available users filtered by organigrama
     */
    getAvailableUsers(documentTypeId: number, directieId: number, compartimentId?: number): Observable<any> {
        let url = `${this.basePath}api/registratura/document-types/${documentTypeId}/available-users/${directieId}`;
        if (compartimentId) {
            url += `/${compartimentId}`;
        }
        url += `?view_all=1`; // Always view all for assignment context
        // document types section
        return this.http.get(url, this.httpOptions);
    }

    /**
     * Get available functii
     */
    getAvailableFunctii(): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/available-functii`;
        return this.http.get(url, this.httpOptions);
    }

    /**
     * Get available directii with compartimente
     */
    getAvailableDirectii(): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/available-directii`;
        return this.http.get(url, this.httpOptions);
    }

    /**
     * Get compartimente for a specific directie
     */
    getCompartimenteByDirectie(directieId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/available-directii/${directieId}/compartimente`;
        return this.http.get(url, this.httpOptions);
    }

    /**
     * Get assignment statistics for a cerere type
     */
    getAssignmentStatistics(documentTypeId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document-types/${documentTypeId}/assignment-statistics`;
        return this.http.get(url, this.httpOptions);
    }

    /**
     * Get available users filtered by directie and optional compartiment (generic, no document type)
     * Used for template redaction configuration
     */
    getAvailableUsersGeneric(directieId: number, compartimentId?: number): Observable<any> {
        let url = `${this.basePath}api/registratura/document-types/available-users/${directieId}`;
        if (compartimentId) {
            url += `/${compartimentId}`;
        }
        return this.http.get(url, this.httpOptions);
    }

}
